module.exports = ".text-la {\n    color: #b8473d;\n}\n\n.btn-la {\n    color: white !important;\n    background-color: #b8473d !important;\n}"